import React from "react"
import "./src/styles/theme/fonts.scss"

import "./src/styles/global.scss"
import AiEfficiencyModalGate from "./src/components/common/AiEfficiencyModalGate"
import {
  isUserInBlockedModalRegion,
  syncGeoModalRegionFromCache,
} from "./src/utils"

// Viewport/queue prefetch only — does NOT stop Link hover `loadPage()`.
export const disableCorePrefetching = () => true

// Gatsby Link onMouseEnter → ___loader.hovering() → loadPage() injects
// other pages' CSS into <head>, which changes fonts site-wide on hover.
const disableHoverPageLoad = () => {
  if (typeof window === "undefined" || !window.___loader) return false
  window.___loader.hovering = () => {}
  return true
}

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <AiEfficiencyModalGate />
  </>
)

export const onClientEntry = () => {
  if (typeof window === "undefined") return

  if (!disableHoverPageLoad()) {
    const id = setInterval(() => {
      if (disableHoverPageLoad()) clearInterval(id)
    }, 50)
    setTimeout(() => clearInterval(id), 5000)
  }

  syncGeoModalRegionFromCache()

  if (window.location.pathname.startsWith("/events")) {
    const $ = require("jquery")
    require("bootstrap/dist/js/bootstrap.bundle.min.js")

    window.$ = $
    window.jQuery = $
    window.Popper = require("@popperjs/core")
  }

  function loadWonderchat() {
    if (window.__wonderchatInjected) return
    window.__wonderchatInjected = true
    const s = document.createElement("script")
    s.src = "https://app.wonderchat.io/scripts/wonderchat-seo.js"
    s.setAttribute("data-name", "wonderchat-seo")
    s.setAttribute("data-address", "app.wonderchat.io")
    s.setAttribute("data-id", "cmm8xzizr0237v99d8q0ny28r")
    s.setAttribute("data-widget-size", "normal")
    s.setAttribute("data-widget-button-size", "normal")
    document.body.appendChild(s)
  }
  const loadChatIfAllowed = () => {
    isUserInBlockedModalRegion()
      .then(blocked => {
        if (!blocked) loadWonderchat()
      })
      .catch(() => {})
  }

  if (document.body) {
    loadChatIfAllowed()
  } else {
    window.addEventListener("DOMContentLoaded", loadChatIfAllowed, {
      once: true,
    })
  }
}

export const onInitialClientRender = () => {
  disableHoverPageLoad()
}
